const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const GET_PLANS_FROM_AEM = 'GET_PLANS_FROM_AEM';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const GET_PLANS_AEM_SUCCESS = 'GET_PLANS_AEM_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_PLANS_FROM_API = 'GET_PLANS_FROM_API';
const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
const UPDATE_SELECTED_OPTION = 'UPDATE_SELECTED_OPTION';
const HIDE_NOTIFICATION_BAR = 'HIDE_NOTIFICATION_BAR ';
const UPDATE_PROCESS_STEP_SETUP = 'UPDATE_PROCESS_STEP_SETUP';
const SETUP_INVALIDCASE_ERROR = 'SETUP_INVALIDCASE_ERROR';
const DEVICE_SETUP_ERROR = 'DEVICE_SETUP_ERROR';
const CEF_DEVICE_SETUP_ERROR = 'CEF_DEVICE_CF_SETUP_ERROR';

export {
  GET_DATA_FROM_API,
  GET_PLANS_FROM_AEM,
  HIDE_NOTIFICATION_BAR,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  GET_PLANS_AEM_SUCCESS,
  ERR_OCCURED,
  GET_PLANS_FROM_API,
  GET_PLANS_SUCCESS,
  UPDATE_SELECTED_OPTION,
  UPDATE_PROCESS_STEP_SETUP,
  SETUP_INVALIDCASE_ERROR,
  DEVICE_SETUP_ERROR,
  CEF_DEVICE_SETUP_ERROR,
};
